import {Component, OnInit, ViewContainerRef, Renderer2, ApplicationRef, ViewChild} from '@angular/core';
import {TimeCardService} from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card.service';
import {User} from 'projects/core/src/lib/login/data/user';
import {PayPeriod} from 'projects/app-misc/src/app/modules/punch-time-widget/data/pay-period';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import * as moment from 'moment';
import {MatDialog} from '@angular/material/dialog';
import {
  PdfPreviewDialogComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/pdf-preview-dialog/pdf-preview-dialog.component';
import {TimesheetsReportDialogComponent} from './timesheets-report-dialog/timesheets-report-dialog.component';
import {Editions} from 'projects/app-misc/src/app/modules/punch-time-widget/data/report-data/editions';
import {MatSnackBarRef, SimpleSnackBar, MatSnackBar} from '@angular/material/snack-bar';
import {UserService} from 'projects/core/src/lib/login/data/user.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Dropdown} from 'primeng/dropdown';
import {MiscSnackBarService} from '../../../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {CsvImportExportDialogComponent} from './csv-import-export-dialog/csv-import-export-dialog.component';

export class PrintPayPeriod {
  payPeriod: PayPeriod;
  selected: boolean;
}

interface DatePeriod {
  start: string
  finish: string
  startDate: Date
  finishDate: Date
}


@Component({
  selector: 'app-approvals-page',
  templateUrl: './approvals-page.component.html',
  styleUrls: ['./approvals-page.component.scss'],
  providers: [DeviceDetectorService]
})
export class ApprovalsPageComponent implements OnInit {
  currentUser: User;

  showAll = false;

  approvalsToPrint: PrintPayPeriod[] = [];

  selectedApprovalCounter = 0;
  approvalCounter: number;

  selectedPayPeriod: DatePeriod;
  lastPayPeriods: DatePeriod[];

  changes: Editions[];

  hoursToFill: number;

  activeSnackBar: MatSnackBarRef<SimpleSnackBar>

  users: User[];
  selectedUser: User;
  showUsersDropdown = false;

  @ViewChild('usersDropdown', {static: true})
  dropDown: Dropdown

  isMobile: boolean;

  loadingSpinnger = false;

  contractorIndex = -1;

  constructor(
    protected deviceDetector: DeviceDetectorService,
    private snackBar: MatSnackBar,
    private miscSnackBarService: MiscSnackBarService,
    private dialog: MatDialog,
    private timeCardsService: TimeCardService,
    private userService: UserService,
    protected renderer: Renderer2,
    protected viewContainerRef: ViewContainerRef,
    private appStateQuery: AppStateQuery,
    protected appRef: ApplicationRef
  ) {
  }

  ngOnInit() {
    this.appStateQuery.currentUser$.subscribe(currentUser => {
      this.currentUser = currentUser
      this.userService.getTrackUsers().subscribe(users => {
        this.users = users;
        this.selectedUser = this.users.find(user => user.id === this.currentUser.id);
        this.showUsersDropdown = true;
      })
    });

    this.getPayPeriods();
    this.isMobile = this.deviceDetector.isMobile();

  }

  getPayPeriods() {
    this.timeCardsService.getPayPeriods(26).subscribe(periods => {

      this.lastPayPeriods = periods.map(period => {
        return {
          start: period.start,
          finish: period.finish,
          startDate: moment(period.start).toDate(),
          finishDate: moment(period.finish).toDate(),
        }
      })

      if (!this.selectedPayPeriod) {
        this.selectedPayPeriod = this.lastPayPeriods[0]
      }
      this.updatePeriods(this.selectedPayPeriod.start, this.selectedPayPeriod.finish)
    })
  }

  updatePeriods(start: string, finish: string) {
    this.selectedApprovalCounter = 0;
    this.showAll = false;
    this.loadingSpinnger = true;

    this.timeCardsService.getPayPeriodsByDate(start, finish).subscribe(approvals => {
      this.approvalCounter = approvals.length


      this.approvalsToPrint = approvals.map(payPeriod => ({
        payPeriod,
        selected: false
      })).sort((a, b) => {
        const af = a.payPeriod.user.isContractor;
        const bf = b.payPeriod.user.isContractor;
        const as = a.payPeriod.user.lastName;
        const bs = b.payPeriod.user.lastName;

        if (af === bf) {
          return (as < bs) ? -1 : (as > bs) ? 1 : 0;
        } else {
          return (af < bf) ? -1 : 1;
        }
      })

      this.contractorIndex = this.approvalsToPrint.findIndex(app => app.payPeriod.user.isContractor)

      this.timeCardsService.getInfoAboutChanges(start, finish).subscribe(changes => {
        this.changes = changes;
      })

      this.loadingSpinnger = false;

    }, () => {
      this.loadingSpinnger = false;
    })
  }

  approve(approval: PayPeriod) {
    this.timeCardsService.togglePayPeriod(
      approval.user.id,
      moment(approval.start).format('YYYY-MM-DD'),
      moment(approval.finish).format('YYYY-MM-DD'))
      .subscribe(() => {
        approval.approved = !approval.approved;
      }, error => {
        this.miscSnackBarService.openErrorSnackBar(error.message)
      })
  }

  openSheets(payPeriod: PayPeriod) {
    const panelClass = ['time-sheets-period-dialog']

    if (this.isMobile) {
      panelClass.push('FULLSCREEN-DIALOG')
    }
    if (payPeriod.user.trackWorkTime) {
      const dialogRef = this.dialog.open(TimesheetsReportDialogComponent, {
        data: {
          payPeriod,
          isMobile: this.isMobile
        },
        panelClass
      });

      dialogRef.afterClosed().subscribe(() => {
        this.updatePeriods(this.selectedPayPeriod.start, this.selectedPayPeriod.finish)
      });
    }
  }

  openPdfPeriod(period: PayPeriod): void {
    this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: `${period.user.name} ${moment(period.start).format('MMM D')} - ${moment(period.finish).format('MMM D')}`,
        link: '/time_card/user/' + period.user.id + '/punch-time/report/' + moment(period.start).format('YYYY-MM-DD') + ':' + moment(period.finish).format('YYYY-MM-DD'),
        showSendButton: false

      },
      panelClass: 'pdf-preview-dialog'
    });
  }

  toogleToPrint(status: any) {
    if (status.checked) {
      this.selectedApprovalCounter++
    } else {
      this.selectedApprovalCounter--
    }

    if (this.selectedApprovalCounter !== this.approvalCounter) {
      this.showAll = false;
    } else if (this.selectedApprovalCounter === this.approvalCounter) {
      this.showAll = true;
    }
  }

  toggleAll(status: any) {

    this.approvalsToPrint.forEach(approval => {
      approval.selected = status.checked;
    })

    this.selectedApprovalCounter = this.approvalCounter
    if (!status.checked) {
      this.selectedApprovalCounter = 0
    }
  }

  printAll() {
    const usersString = this.approvalsToPrint
      .filter(approval => approval.selected)
      .map(approval => approval.payPeriod.user.id)
      .join(',')

    if (usersString) {
      this.dialog.open(PdfPreviewDialogComponent, {
        data: {
          dialogHeader: 'Pay Period',
          link: '/time_card/punch-time/report/' + moment(this.approvalsToPrint[0].payPeriod.start).format('YYYY-MM-DD') + ':' + moment(this.approvalsToPrint[0].payPeriod.finish).format('YYYY-MM-DD') + '?userIds=' + usersString,
          showSendButton: false

        },
        panelClass: 'pdf-preview-dialog'
      });
    }

  }

  fillHours() {
    if (typeof this.hoursToFill !== 'undefined') {
      this.timeCardsService.fillHours(this.selectedUser.id, this.selectedPayPeriod.start, this.selectedPayPeriod.finish, this.hoursToFill).subscribe(() => {
        this.updatePeriods(this.selectedPayPeriod.start, this.selectedPayPeriod.finish)
        this.miscSnackBarService.openSuccessSnackBar('Success')
        this.hoursToFill = undefined;
      })
    }
  }

  openCsvDialog() {
    this.dialog.open(CsvImportExportDialogComponent, {
      panelClass: 'csv-import-export-dialog'
    });
  }

}
